import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import './gmaps';
// import createMap from './gmaps';

import Swiper from 'swiper';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';

Swiper.use([Autoplay, FreeMode, Navigation]);

import 'swiper/css';
import 'swiper/css/navigation';


// COOKIES
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied'
});

// Función para capturar parámetros UTM de la URL
function getUTMParams() {
    const params = {};
    location.search.substr(1).split('&').forEach(param => {
    const [key, value] = param.split('=');
    if (key.startsWith('utm_')) {
        params[key] = decodeURIComponent(value);
    }
    });
    return params;
}

// Almacena las UTM en localStorage si existen
const utmParams = getUTMParams();
if (Object.keys(utmParams).length > 0) {
    localStorage.setItem('utmParams', JSON.stringify(utmParams));
}

// Función para manejar el consentimiento del usuario
function acceptCookies(consent) {
    // Almacena el consentimiento en una cookie durante 30 días
    document.cookie = `cookieConsent=${JSON.stringify(consent)}; path=/; max-age=${30 * 24 * 60 * 60}`;

    // Oculta el banner de cookies
    $('.cookie-banner').removeClass('active');


    gtag('consent', 'update', {
    'ad_storage': consent.ad ? 'granted' : 'denied',
    'analytics_storage': consent.analytics ? 'granted' : 'denied'
    });

    // Si se aceptan cookies analíticas, carga GTM y envía el evento page_view con UTM
    if (consent.analytics) {
    const storedUTM = JSON.parse(localStorage.getItem('utmParams') || '{}');

    // Cargar Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=GTM-M2P2WLPR`;
    document.head.appendChild(gtmScript);


    window.dataLayer.push({
        event: 'gtm.js',
        ...storedUTM
    });
    }
}

// Función para obtener el consentimiento almacenado en cookies
function getCookieConsent() {
    const consentCookie = document.cookie.split('; ').find(row => row.startsWith('cookieConsent='));
    return consentCookie ? JSON.parse(consentCookie.split('=')[1]) : null;
}

// Verifica si ya existe consentimiento y actúa en consecuencia
window.onload = function () {
    const consent = getCookieConsent();
    if (consent && consent.analytics) {
        // Si ya hay consentimiento previo, carga GTM y envía el evento page_view
        gtag('consent', 'update', {
            'ad_storage': consent.ad ? 'granted' : 'denied',
            'analytics_storage': consent.analytics ? 'granted' : 'denied'
        });

        const storedUTM = JSON.parse(localStorage.getItem('utmParams') || '{}');
        const gtmScript = document.createElement('script');
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=GTM-M2P2WLPR`;
        document.head.appendChild(gtmScript);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gtm.js',
            ...storedUTM
        });
    } else {
        // Si no hay consentimiento previo, muestra el banner de cookies
        $('.cookie-banner').addClass('active');
    }



};

function enviarForm() {
    var dataForm = $('#contact').serializeArray();
    $('.btn-send').hide();
    $('.sending').show();

    $.ajax({
        url: '/email',
        method: 'POST',
        data: dataForm,
        // processData: false,
        // contentType: false,
        dataType: 'json',
        success: function (data) {
            if (!data.ok) {
                $('.btn-send').show();
                $('.sending').hide();
                alert('Se ha producido un error al enviar su consulta, contacte con nosotros en info@iks.es');
                return false;
            }
            $('#contact').hide();
            $('.text-sended').show();
        },
        error: function () {
            $('.btn-send').show();
            $('.sending').hide();
            alert('Se ha producido un error al enviar su consulta, contacte con nosotros en info@iks.es');
        }
    });
}

$(function() {
    $('.closemenu').on('click', function(e){
        e.preventDefault();
        $('.menu').removeClass('open')
    });

    $('.hamburger-menu').on('click', function(e){
        e.preventDefault();
        $('.menu').addClass('open')
    });

    $('.scroll').on('click', function(e){
        $('.menu').removeClass('open')
    });

    $('.read-more').on('click', function(e){
        e.preventDefault();
        $('.text').find('span').show();
        $('.read-more').remove();
    });

    $('form#contact').on('submit', function(e){
        e.preventDefault();
        enviarForm();
    });


    if (window.location.hash === '#gracias') {
        alert('Solicitud Enviada. Gracias');
        history.replaceState(null, null, window.location.pathname + window.location.search);
    }


    // COOOKIES
    // Aceptar
    $(".btn-confirm-cookies-all").on("click", function(e) {
        e.preventDefault();

        // Cerrar settings
        $('.modal-cookies-settings').hide();
        $('.cookie-banner').addClass('active');

        // Cerrar cookie
        $('.cookie-banner').slideUp({
            start: function () {
                $(this).css({display: "flex"})
            }
        });

        // Send config
        acceptCookies({analytics: true, ad: true});
    });

    $(".btn-confirm-cookies").on("click", function(e) {
        e.preventDefault();

        // Cerrar settings
        $('.modal-cookies-settings').hide();
        $('.cookie-banner').addClass('active');

        // Cerrar cookie
        $('.cookie-banner').slideUp({
            start: function () {
                $(this).css({display: "flex"})
            }
        });

        // Send config
        if($('.with-analytics').hasClass('active')) {
            acceptCookies({analytics: true, ad: true});
        } else {
            acceptCookies({analytics: false, ad: false});
        }
    });

    // Opciones
    $(".btn-options-cookies").on("click", function(e) {
        e.preventDefault();
        $('.cookie-banner').removeClass('active');
        $('.modal-cookies-settings').addClass('active');
    });

    // Cerrar Setting
    $(".modal-cookies-settings-save__reject-button, .modal-cookies-settings-close").on("click", function(e) {
        e.preventDefault();
        $('.modal-cookies-settings').removeClass('active');
        $('.cookie-banner').addClass('active');
    });

    // Rechazar
    $(".modal-cookies-settings-options-reject").on("click", function(e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).next().removeClass('active');
        $(this).parent().removeClass('active');
    });

    // Aceptar
    $(".modal-cookies-settings-option-button-agree").on("click", function(e) {
        e.preventDefault();
        $(this).addClass('active');
        $(this).prev().removeClass('active');
        $(this).parent().addClass('active');
    });


    // if (!$.esMovil()) {
    //     $('video').css('display', 'block');
    // }







    const nextBtn = document.querySelector(".arch-nav--next");
    const prevBtn = document.querySelector(".arch-nav--prev");
    const barEl = document.querySelector(".arch-progress__bar");

    const vivNextBtn = document.querySelector(".viviendas-nav--next");
    const vivPrevBtn = document.querySelector(".viviendas-nav--prev");
    const vivBarEl  = document.querySelector(".viviendas-progress__bar");

    // helper para formatear 1 => "01"
    function pad2(n) {
        return n.toString().padStart(2, "0");
    }

    const swiper = new Swiper(".arch-swiper", {
        speed: 500,
        allowTouchMove: true, // puedes poner false en desktop si quieres solo flechas
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        on: {
            init(sw) {
                updateUI(sw);
            },
            slideChange(sw) {
                updateUI(sw);
            }
        }
    });

    function updateUI(sw) {
        const total = sw.slides.length;
        const realIndex = sw.realIndex; // índice actual empezando en 0
        const current = realIndex + 1;

        // actualiza numerador

        // actualiza barra progreso
        // ej: slide 1 de 3 => ~33%, slide 2 => ~66%, etc.
        const progressPct = (current / total) * 100;
        barEl.style.width = progressPct + "%";

        // deshabilita botones en extremos
        // (solo tiene sentido si loop:false)
        if (realIndex === 0) {
            prevBtn.disabled = true;
        } else {
            prevBtn.disabled = false;
        }

        if (realIndex === total - 1) {
            nextBtn.disabled = true;
        } else {
            nextBtn.disabled = false;
        }
    }

    const viviendasSwiper = new Swiper(".viviendas-swiper", {
        loop: false,
        speed: 500,
        allowTouchMove: true,
        slidesPerView: 2.5,
        spaceBetween: 24,

        // si quieres varias cards visibles en desktop:
        breakpoints: {
            400: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 24,
            },
            1300: {
                slidesPerView: 2.5,
                spaceBetween: 24,
            }
        },

        navigation: {
            prevEl: vivPrevBtn,
            nextEl: vivNextBtn,
        },

        on: {
            init(sw) {
                const total = sw.slides.length;
                updateViviendasUI(sw);
            },
            slideChange(sw) {
                updateViviendasUI(sw);
            }
        }
    });


    function updateViviendasUI(sw) {
        if (!sw) return;

        const total = sw.slides.length - 1;
        const realIndex = sw.realIndex;
        const current = realIndex + 1;

        // numerador tipo 01 / 03

        // barra progreso
        if (vivBarEl) {
            const progressPct = (current / total) * 100;
            vivBarEl.style.width = progressPct + "%";
        }

        // deshabilitar flechas en extremos
        if (vivPrevBtn) vivPrevBtn.disabled = realIndex === 0;
        if (vivNextBtn) vivNextBtn.disabled = realIndex === total - 1;
    }
});
